import React from 'react';

import SearchTeaser from '../../../components/SearchTeaser';
import HelpPageDetail from './Detail';
import HelpPageTeaser from './Teaser';

const NodeHelpPage = ({ entity, viewMode }) => {
  switch (viewMode) {
    case 'search_teaser':
      return <SearchTeaser entity={entity} />;
    case 'teaser':
      return <HelpPageTeaser entity={entity} />;
    case 'full':
    default:
      return <HelpPageDetail entity={entity} />;
  }
};

export default NodeHelpPage;
